import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '../../../../../../shared/components/Notistack/Notistack';

export interface IRateCard {
  lenderId: string;
  fileContents: string;
  documentTypeId: string;
  fileName: string;
}

interface IUpdateRateCard {
  fileName: string;
  fileContent: string;
  documentType?: string;
  userId: number;
}

export const requestUpdateRateCard = (lenderId: string, payload: IUpdateRateCard) => {
  const path = `/lender-service/lenderdocuments/${lenderId}`;

  return mutate(path, async() => {
    try {
      await axios.post(path, {
        ...payload,
        documentType: 'RateCard',
      });
    } catch {
      Notistack.generalError();
    }
  });
};
